import React from "react";

import {LeadModel} from "@/typings/models/Lead";

import styles from "./index.less"
import {F} from "@/utils/intl";

const LeadAppointmentBranchService = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  const branchService = lead?.latest_appointment?.branch_service
  if (!branchService?.name) return <div> - </div>
  const content = branchService.name

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F id={"pages.lead.fields.appointmentBranchService"} defaultMessage={"Branch Service"}/></div>
    <div>{content}</div>
  </div>

}

export default LeadAppointmentBranchService
